import { render } from "./DocumentaryCard.vue?vue&type=template&id=102544ba&scoped=true"
import script from "./DocumentaryCard.vue?vue&type=script&lang=js"
export * from "./DocumentaryCard.vue?vue&type=script&lang=js"

import "./DocumentaryCard.vue?vue&type=style&index=0&id=102544ba&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-102544ba"]])

export default __exports__